import React, { FunctionComponent } from 'react';
import { motion } from 'framer-motion';
import { DateTime } from 'luxon';
import { Flex, Tooltip, variables } from '@bitrise/bitkit';
import { BuildCompact, StepCompact } from '@trace/types';
import { STATUS_COLORS_HEX } from '../mappings';

interface Props {
  builds: (BuildCompact | StepCompact)[];
  size: number;
}

const GAP = 4;

const StatusHistory: FunctionComponent<Props> = ({ builds, size }) => {
  const hypot = Math.hypot(size, size);
  const height = hypot * 1.5;
  const width = hypot + hypot * 0.5 * builds.length;

  return (
    <Flex container height={height} width={width}>
      {builds
        .slice()
        .reverse()
        .map(({ status, timestamp }, i) => (
          <Tooltip
            // eslint-disable-next-line react/no-array-index-key
            key={`${status}-${i}`}
            title={`${status} ${DateTime.fromISO(timestamp.value).toRelative()}`}
          >
            {(props) => (
              <motion.div
                {...props}
                animate={{
                  backgroundColor: STATUS_COLORS_HEX[status],
                  rotate: '45deg',
                  x: (hypot * 0.5 + GAP) * i - GAP,
                  y: i % 2 ? hypot * 0.5 + GAP : 0,
                }}
                initial={{
                  backgroundColor: variables.colorGray2,
                  rotate: '0deg',
                  x: width,
                  y: height / 2,
                }}
                style={{
                  position: 'absolute',
                  borderRadius: 4,
                  height: size,
                  width: size,
                }}
                transition={{
                  delay: (50 * i) / 1000,
                }}
              />
            )}
          </Tooltip>
        ))}
    </Flex>
  );
};

export default StatusHistory;
